var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FormItemContainer',{attrs:{"title":_vm.title}},[_c('v-select',_vm._b({attrs:{"item-text":_vm.text,"item-value":_vm.model,"items":_vm.items,"rules":_vm.myRules,"label":_vm.label,"solo":""},on:{"input":_vm.onInput}},'v-select',{ ..._vm.$attrs, ..._vm.$props },false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }